import { m } from "./dateUtils";

const DEFAULT_TRIP_STATUS = {
    situacao: 'Agendada',
    situacaoKey: 'agendada',
    barColor: 'primary',
    detaTrip: '',
    statusTrip: 0,
    naoRealizada: false
};

const NOT_REALIZED_TRIP_STATUS = {
    situacao: 'Não Realizada',
    situacaoKey: 'nao_realizada',
    barColor: 'error',
    detaTrip: '(não realizada)',
    statusTrip: 3,
    naoRealizada: true
};

export default function resolveTripStatus(
    status,
    finalPrev =  null
) {

    // Análise existente sempre tem prioridade
    if (status) {
        return status;
    }

    const limite = m(finalPrev).add(1, 'hour');

    if (m().isAfter(limite)) {
        return NOT_REALIZED_TRIP_STATUS;
    }

    return DEFAULT_TRIP_STATUS;
}